import Link from 'next/link';
import { Button } from '@repo/ui/components/button';
import { describeApiError } from '@/lib/api-client';

/** The Positions card's body when the holdings read failed. */
export function HoldingsUnavailable({ error }: { error?: unknown }) {
  return (
    <div className="p-8 text-center">
      <p className="text-rowa-body-md text-rowa-text-primary">
        Holdings are unavailable.
      </p>
      <p className="text-rowa-body-sm text-rowa-text-secondary mt-1">
        Retry after the portfolio service reconnects.
      </p>
      {describeApiError(error) && (
        <p className="text-rowa-label-sm text-rowa-text-tertiary mt-2 font-mono break-all">
          {describeApiError(error)}
        </p>
      )}
    </div>
  );
}

/** The Positions card's body when the wallet holds nothing recognised. */
export function NoHoldings() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 px-6 py-12 text-center">
      <div>
        <p className="text-rowa-body-md text-rowa-text-primary">
          No holdings are recognized on this network yet.
        </p>
        <p className="text-rowa-body-sm text-rowa-text-secondary mt-1">
          Review available vaults when you are ready to allocate capital.
        </p>
      </div>
      <Button variant="secondary" size="sm" asChild>
        <Link href="/vaults">Browse vaults</Link>
      </Button>
    </div>
  );
}
